import React from "react";
import {FormattedMessage, useIntl} from "react-intl";
import {DayReport} from "@/data/entities/dayReport";
import ReportCard from "@widgets/reports/dayReport/card/ReportCard";
import PaymentMethodTotal from "@widgets/reports/dayReport/payments/PaymentMethodTotal";
import {onlineShare} from "@widgets/reports/dayReport/DayReportUtils";

type Props = {
    dayReport: DayReport,
};

/**
 * Gross revenue per payment method (Mollie and PIN, together the gross
 * revenue), and the tips, which are not revenue.
 */
const DayReportPayments = ({dayReport}: Props) => {
    const intl = useIntl();
    const online: number | null = onlineShare(dayReport);
    const inPerson: number | null = online === null ? null : 100 - online;

    return (
        <ReportCard title={<FormattedMessage id={"dayReport.payments"}/>}>
            <div className={"flex flex-col gap-5"}>
                {
                    online !== null &&
                    <div
                        role={"img"}
                        aria-label={intl.formatMessage({id: "dayReport.payments.share"}, {online, inPerson})}
                        className={"flex h-3.5 overflow-hidden rounded-full bg-gray-200 dark:bg-slate-700"}
                    >
                        <div className={"bg-blue-600"} style={{width: `${online}%`}}/>
                        <div className={"bg-amber-500"} style={{width: `${inPerson}%`}}/>
                    </div>
                }

                <div className={"grid grid-cols-1 gap-4 sm:grid-cols-2"}>
                    <PaymentMethodTotal
                        label={<FormattedMessage id={"dayReport.paidOnline"}/>}
                        amount={dayReport.paidOnline}
                        orderCount={dayReport.onlinePaidOrderCount}
                        share={online}
                        colorClassName={"bg-blue-600"}
                    />
                    <PaymentMethodTotal
                        label={<FormattedMessage id={"dayReport.paidInPerson"}/>}
                        amount={dayReport.paidInPerson}
                        orderCount={dayReport.inPersonPaidOrderCount}
                        share={inPerson}
                        colorClassName={"bg-amber-500"}
                    />
                </div>
            </div>
        </ReportCard>
    );
};

export default DayReportPayments;